import React from 'react'

import moment from 'moment'

import { Box, Typography, TextField } from '@material-ui/core'

import { Link, useHistory } from 'react-router-dom'
import { routes } from 'routes'

import TableTaxes from './components/TableTaxes'
import { KeyboardDatePicker } from '@material-ui/pickers'
import Footer from './components/Footer'

import useFetch from 'hooks/useFetch'
import * as service from 'service'
import DetachedInvoiceContext from 'contexts/DetachedInvoiceContext'

const DetachedInvoiceSettings = () => {
  const context = React.useContext(DetachedInvoiceContext)
  const history = useHistory()
  const [dueDate, setDueDate] = React.useState(false)
  const [taxInvoices, setTaxInvoices] = React.useState(
    context.data.isTax || true,
  )
  const [taxList, setTaxList] = React.useState([...context.data.taxes])
  const [invalidDate, setInvalidDate] = React.useState('')

  const { response, isLoading } = useFetch(service.recurrence.taxes.get, {
    tax: { active: true },
  })

  const handleData = element => {
    setDueDate(moment(element).format('YYYY/MM/DD'))
  }

  const handleChange = event => {
    setTaxInvoices(event.target.value)
  }

  const handleChangeTax = (event, tax) => {
    if (event.target.checked) {
      setTaxList([...taxList, tax])
    } else {
      setTaxList(taxList.filter(currentTax => tax.id !== currentTax.id))
    }
  }

  const goNext = () => {
    context.setData(data => ({
      ...data,
      dueDate: dueDate,
      taxes: taxList,
      isTax: taxInvoices,
    }))
    history.push(routes.invoices.steps.confirm)
  }

  React.useEffect(() => {
    if (context.data.dueDate) {
      setDueDate(context.data.dueDate)
    }
  }, [context])

  return (
    <Box p={1}>
      <form>
        <Box
          p={2}
          mt={2}
          display="flex"
          flexGrow={1}
          flexDirection={{
            xs: 'column',
            sm: 'row',
          }}
        >
          <Box flex={1} mr={10}>
            <Typography color="textSecondary">
              Informe o vencimento da fatura
            </Typography>
            <KeyboardDatePicker
              margin="dense"
              variant="outlined"
              placeholder="Data de vencimento da fatura"
              format="dd/MM/yyyy"
              name="from"
              disablePast
              value={dueDate || null}
              invalidDateMessage="Data invalida"
              minDateMessage="A data não deve ser anterior a data de hoje"
              maxDateMessage="A data não deve ser muito distante"
              onError={e => setInvalidDate(e)}
              fullWidth
              onChange={handleData}
            ></KeyboardDatePicker>
          </Box>
          <Box flex={1} mr={10}>
            <Typography color="textSecondary">Emitir nota fiscal?</Typography>
            <TextField
              margin="dense"
              variant="outlined"
              SelectProps={{ native: true }}
              select
              fullWidth
              value={taxInvoices}
              onChange={handleChange}
              helperText="A emissão ocorrerá conforme as configurações da conta"
            >
              <option value={true}>Sim</option>
              <option value={false}>Não</option>
            </TextField>
          </Box>
        </Box>
      </form>
      <Box px={2} pt={4}>
        <Typography color="textSecondary">
          Selecione os impostos que serão aplicados (opcional)
        </Typography>
      </Box>
      {!isLoading && (
        <Box p={2}>
          <TableTaxes
            taxes={response?.data.taxes}
            onChangeTax={handleChangeTax}
            checkedTaxes={taxList}
          />
        </Box>
      )}
      <Box p={2}>
        <Footer
          prevButtonProps={{
            component: Link,
            to: routes.invoices.steps.selectPlan,
          }}
          nextButtonProps={{
            onClick: goNext,
            disabled: !dueDate || !!invalidDate,
          }}
        />
      </Box>
    </Box>
  )
}

export default DetachedInvoiceSettings
